import { observer } from "mobx-react";
import * as React from "react";
import { Area } from "../General/Area";
import { PDF } from "./PDF";


interface IPdfViewProps {
	id: string;
	searchTerm: string;
	docId: string;
	docLanguage: string;
	collectionId: string;
	downloadName: string;
	canDownload: boolean;
	fileName: string;
	originalFilename: string;
	isDeleted: boolean;
}

@observer
export class PdfView extends React.Component<IPdfViewProps, {}> {	
	render() {
		return <Area>
			<PDF
				id={this.props.id}
				searchTerm={this.props.searchTerm}
				docId={this.props.docId}
				docLanguage={this.props.docLanguage}
				collectionId={this.props.collectionId}
				downloadName={this.props.downloadName}
				canDownload={this.props.canDownload}
				fileName={this.props.fileName}
				isDeleted={this.props.isDeleted}
				originalFilename={this.props.originalFilename}
			/>
		</Area>;
	}

}